import type { PaymentStatus } from '@repo/api-contracts';
import { ArrowLeft } from 'lucide-react';
import type { ReactElement } from 'react';
import { PAYMENT_STATUS_LABELS } from '@/entities/payment';
import { Button, PageHeader, StatusBadge } from '@/shared/ui';
import { PAYMENT_STATUS_TONES } from './payment-status-tones';

export interface PaymentDetailHeaderProps {
  /** 받은 결제의 상태 — 받기 전·실패·잘못된 주소면 null 이고 배지가 없다. */
  readonly status: PaymentStatus | null;
  /** "목록으로" — 페이지가 결제 내역으로 옮긴다. */
  readonly onBack: () => void;
}

/** 결제 상세 머리말 — 제목·결제 상태 배지·목록으로 버튼. 주문 상세 머리말과 같은 자리·크기. */
export const PaymentDetailHeader = ({ status, onBack }: PaymentDetailHeaderProps): ReactElement => (
  <PageHeader
    title="결제 상세"
    description={
      status ? (
        <StatusBadge tone={PAYMENT_STATUS_TONES[status]}>
          {PAYMENT_STATUS_LABELS[status].label}
        </StatusBadge>
      ) : undefined
    }
    actions={
      <Button type="button" variant="outline" className="h-10 px-5" onClick={onBack}>
        <ArrowLeft aria-hidden="true" />
        목록으로
      </Button>
    }
  />
);
